import { authClient } from './client';
import ExtractErrorMessage from "../utils/extractErrorMessage";

const announcementService = {

    getAll: async (page = 0, limit = 10, status = undefined, search = undefined) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());

        if (status) params.append('status', status);
        if (search) params.append('search', search);

        try {
            return (await authClient.get(`/announcements/get-all?${params.toString()}`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
    
    getById: async (id) => {
        try {
            return (await authClient.get(`/announcements/${id}/get-one`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
    
    create: async (data) => {
        try {
            return (await authClient.post('/announcements/create', data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
    
    update: async (id, data) => {
        try {
            return (await authClient.put(`/announcements/${id}/update`, data)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
    
    delete: async (id) => {
        try {
            return await (await authClient.delete(`/announcements/${id}/delete`)).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
    
    toggleStatus: async (id) => {
        try {
            return (await authClient.patch(`/announcements/${id}/toggle-status`, {})).data;
        } catch (error) {
            const message = ExtractErrorMessage(error, "Došlo je do greške");
            return { data: null, success: false, message: message };
        }
    },
};

export default announcementService;